import "./tech-grid.css";

export default function TechStackGrid({ items }) {
  return (
    <div className="tech-grid">
      {items.map((item) => (
        <div className="tech-card" key={item.name}>
          <item.icon />
          <span>{item.name}</span>
        </div>
      ))}
    </div>
  );
}
